<template>
    <el-form
            class="mam-master-settting setting-inner"
            ref="editform"
            :model="editForm"
            :rules="rules"
    >
        <el-form-item
            prop="stopRatio"
        >
            <p class="self-label lable12">
                {{$t('Stop_loss_ratio')}}
                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content" style="width: 220px">
                        {{$t('stopRatioExplain')}}
                    </div>
                    <i class="el-icon-info tips-icon"></i>
                </el-tooltip>
            </p>
            <div class="input-prefix-outer pr">
                <el-input :placeholder="phFileter($t('Not_set'),this)" v-model="editForm.stopRatio"></el-input>
                <div class="suffix pa">%</div>
            </div>
        </el-form-item>
        <el-form-item>
            <slot></slot>
        </el-form-item>
    </el-form>
</template>

<script>
    import { phFileter } from '../../utils/common';
    import { maxTwoFloatOrNone } from '@/utils/validate'
  export default {
    name: 'mamMasterSetting',
    props: {
      formData: {
        type: Object,
        default(){
          return {
            stopRatio: ''
          }
        }
      }
    },
    data() {
      let _this = this;
      let validateStopRatio = (rule, value, callback) => {
        if(value === ''){
          callback();
        }else {
          if(!maxTwoFloatOrNone(value) && (value < 100 || value > 100)){
            callback(new Error(_this.$t('StopRatioValiteTips')))
          }else {
            callback()
          }
        }
      };
      return {
        editForm: {
          stopRatio: '',
        },
        rules:{
          stopRatio:[
            {validator: validateStopRatio, trigger: 'blur'}
          ],
        },
      };
    },
    watch:{
      formData:{
        handler(newValue){
            this.editForm = JSON.parse(JSON.stringify(newValue));
        },
        deep: true,
      }
    },
    methods: {
      phFileter,
      validate(){
        this.$refs.editform.validate((valid) => {
          if(valid){
            console.log('pass validate');
            this.$emit('send-form', this.editForm);
          }else {
            console.log('error');
          }
        })
      },
    }
  };
</script>

<style lang="scss" scoped>
.mam-master-settting {
    .tips-icon {
        color: #cccccc;
    }
    .input-prefix-outer {
        .prefix {
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #333333;
            z-index: 99;
        }
        /deep/ .input-prefix-ele .el-input__inner{
            padding-left: 100px;
        }
    }
    .suffix {
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        color: #333333;
        z-index: 99;
    }
}
</style>
